import Vue from 'vue'
import App from './App.vue'
// import './plugins/element.js'
import api from './api.js'
import { Toast, Button,Col,Icon, Field, Row, RadioGroup, Radio,Form, CellGroup,Swipe, SwipeItem } from 'vant';
import 'vant/lib/index.css';
import router from './router';
import i18n from './lang';
import "amfe-flexible";
import 'bootstrap/dist/js/bootstrap.min.js'
import store from "./store";
import Vuex from "vuex";
Vue.use(Toast);
Vue.use(Button);
Vue.use(Vuex);
Vue.use(Col);
Vue.use(Row);
Vue.use(Radio);
Vue.use(Field);
Vue.use(RadioGroup);
Vue.use(Form);
Vue.use(CellGroup);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Icon);
Vue.config.productionTip = false
  // main.js文件
Vue.prototype.api = api

new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app')
